import ColumnChartSkeleton from 'components/base/empty-states/skeletons/ColumnChartSkeleton';

const Loader = () => {
  return (
    <div
      data-cy='allocation-over-time-loader'
      style={{ width: '50%', height: '80%' }}
    >
      <ColumnChartSkeleton total={8} />
    </div>
  );
};

export default Loader;
